import React from 'react'
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/product_cat/16001613825223.jpg';
import '../../styles/about.css'

const KozmetikLekeTedavisi = () => {
    return (
        <div>
            <h5 className='main-title'>Leke Tedavisi</h5>
            <hr />
            <p>Yüzde melazma denen yanaklardaki kelebek şeklindeki lekeler, hormonal, hamilelik sonrası ve güneş ışığına bağlı olabilir. Nedene yönelik araştırmalar yapıldıktan sonra peeling veya ilaç tedavileri uygulanabilir. Bu konuda fractional lazerin FDA onayı vardır. Ayda birkez yapılan ve 6 seans süren uygulama sonucunda sonuçlar yüz güldürücüdür. Diğer tedavilere nazaran lazer tedavileri daha etkin tedavilerdir.</p>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />
        </div>
    )
}

export default KozmetikLekeTedavisi